import React, { useEffect, useState } from 'react'
import { postSignup, updateSignup } from '../../redux/ducks/signup';
import { connect } from 'react-redux'
import { Formik,Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { makeStyles, Container, Grid, LinearProgress, Typography, Button } from '@material-ui/core';
import {FormikPersistStore} from '../../component/FormikPersistStore'
import {checkRequiredHandler} from '../../component/FormUtil'
import { Link, useParams } from 'react-router-dom';
import { history,MyMess } from '../../App';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import {isEmail} from '../../utils/Utils';
import Axios from 'axios';
import {useSelector } from 'react-redux';
import { parseStdResponseError, ResendVerify, ResetPassword } from '../../server/WebServiceUrl';

import passwordImage from '../../images/password.png'
import logoImage from '../../images/logo.png'

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import {GreenButton} from '../../component/colorButton';
import LangChangeSelect from '../../component/LangChangeSelect';
import Footer from '../../component/footer';
import Hidden from '@material-ui/core/Hidden';
import LoginBackground from '../../component/backgorund';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        height: '100vh'
    },
    paper: {
        position:'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    landingImage: {
        flex: 1,
        position: 'relative'
      },
      logo: {
        width: '60%'
      },
      cardRoot: {
        minWidth: 545,
        maxWidth: 545,
      },
      langPicker: {
        position: 'absolute',
        top: 15,
        right: 15
      },
      link: {
          color: "#5db4a2",
          '&:visited' :{
            color: "#5db4a2",
          }
      },
      email:{
          fontWeight:600,
          overflowWrap: 'break-word'
      }
  }));

// const checkRequiredHandler = (fields,values,errors) => {
//     fields.forEach(field =>{
//         if(!values[field]){
//             errors[field] = 'Required';
//         }
//     })


//     return errors;
// }

function SendVerify(props) {

    let app = useSelector(state => state.app);
    MyMess.setLanguage(app.lang);
    const classes = useStyles();
    let param = useParams();

    const [formData, setFormData] =useState({
        email:param.email
    })        

    
    const resendHandler = () => {
        const doResend = async () => {
            try{
                let resendResult = await Axios.post(ResendVerify,{
                    "email": formData.email
                })

                let data = resendResult.data
                let error = parseStdResponseError(data);
                if(!error){
                    GlobalSnackBarUtil.open({
                        message:MyMess.general.resendEmailOK                        
                    })
                }
            }catch(e){
                GlobalSnackBarUtil.open({
                    message:MyMess.general.errors.invalidEmailPassword,
                    severity:'error'
                  })    
            }


        }

        doResend();

    }

    return (
        <div>
            <LoginBackground></LoginBackground>
            <div className={classes.langPicker}>
                <LangChangeSelect variant="" />
            </div>             
                            
                <Container component="main" className={classes.root} maxWidth="xl">                    
                    <div className={classes.paper}>
                        <Card className={classes.cardRoot} raised={true}>
                            <CardHeader
                            title={<img src={logoImage} className={classes.logo}/>}
                            />
                            <CardContent>
                            <Typography component="h5" variant="h5" align="center" className={classes.email}>
                                {MyMess.general.verifyEmailTitle}
                            </Typography>

                            <Typography component="h6" variant="h6" align="center">
                                {MyMess.general.verifyEmailMsg} 
                            </Typography>                                            
                            <Typography component="h6" variant="h6" align="center" className={classes.email}>
                            {formData.email}
                            </Typography>                            
                            <Typography component="h6" variant="h6" align="center">
                                {MyMess.general.verifyEmailMsg2} {MyMess.general.verifyEmailMsg3}
                            </Typography>                       
                            
                            
                            <Typography component="h6" variant="h6" align="center">
                                {MyMess.general.verifyEmailMsg4}
                            </Typography>
                            <GreenButton      
                                fullWidth                                                          
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={resendHandler}
                            >
                                {MyMess.general.resendEmail}
                            </GreenButton>
                            <Grid container justify="center">
                                <Grid item>
                                    <Link to="/login" variant="body2" className={classes.link}>
                                        {MyMess.general.returnToLogin}
                                    </Link>
                                </Grid>
                            </Grid>
                            </CardContent>
                            
                        </Card>
                    </div>
                    
                </Container>               
            <Footer />
        </div>
        
    )
}

export default SendVerify;